export default __webpack_public_path__ + "pgnv-assets/ecbd5c1dbc540cbba64fce6712403069.png";